import { firestore } from "@/services/firebase";
import { isNumeric } from "@shared/utils/number-helper";
import firebase from "firebase/app";

class FrontendTimestamp {
  seconds;
  nanoseconds;

  fromDate(date) {
    return firebase.firestore.Timestamp.fromDate(date);
  }
}

class FrontendFieldPath {
  documentId() {
    return firebase.firestore.FieldPath.documentId();
  }
}

class FrontendFieldValue {
  serverTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }
  delete() {
    return firebase.firestore.FieldValue.delete();
  }
  arrayUnion(...elements) {
    return firebase.firestore.FieldValue.arrayUnion(...elements);
  }
  arrayRemove(...elements) {
    return firebase.firestore.FieldValue.arrayRemove(...elements);
  }
  increment(n) {
    return firebase.firestore.FieldValue.increment(n);
  }
}

class FrontendFirestore {
  fieldValue;
  fieldPath;

  constructor() {
    this.timestamp = new FrontendTimestamp();
    this.fieldValue = new FrontendFieldValue();
    this.fieldPath = new FrontendFieldPath();
  }

  collection(path) {
    return firestore.collection(path);
  }
  collectionGroup(path) {
    return firestore.collectionGroup(path);
  }
  doc(path) {
    return firestore.doc(path);
  }
  batch() {
    return firestore.batch();
  }
  runTransaction(updateFunction) {
    return firestore.runTransaction(updateFunction);
  }
}

export function cachedTimeOffset() {
  const firestoreTimeOffset = parseFloat(
    sessionStorage.getItem("firestoreTimeOffset")
  );
  if (!isNumeric(firestoreTimeOffset)) return 0;

  return firestoreTimeOffset;
}

export function serverTimestamp() {
  return firebase.firestore.FieldValue.serverTimestamp();
}

const frontendFirestore = new FrontendFirestore();

export const getFrontendFirestore = () => {
  return frontendFirestore;
};
